import React, { useEffect, useState } from "react";
import Header from "../../../components/Header/Header";
import CustomBtn from "../../../components/Buttons/CustomBtn";
import BodyWrapper from "../../../components/Wrapper/BodyWrapper";
import SearchableTable from "../../../components/Tables/SearchableTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchStockStats } from "../../../store/Slices/StockStatsSlice";
import { StockStatsColumns } from "../../../assets/Columns/StockStatsColumns";
import AddStockModal from "../../../components/Modals/AddStockModal";
import FetchingLoading from "../../../components/Loaders/FetchingLoading";
import { StockDataColumns } from "../../../assets/Columns/StockDataColumns";

const StockStats = () => {
  const [SearchText, setSearchText] = useState("");
  const [OpenAddStockModal, setOpenAddStockModal] = useState(false);

  const dispatch = useDispatch();
  const StockStats = useSelector((state) => state.StockStats);

  useEffect(() => {
    dispatch(fetchStockStats());
  }, [dispatch]);
  return (
    <BodyWrapper>
      <Header
        title="Stock Statistics"
        desc="Overview of your stocks management"
      >
        <CustomBtn
          title={"Add Stock"}
          onClick={() => {
            setOpenAddStockModal(true);
          }}
        />
      </Header>

      <div className="w-full mt-10 flex justify-center items-center">
        {StockStats.loading ? (
          <div className="flex flex-1 justify-center items-center">
            <FetchingLoading />
          </div>
        ) : (
          <SearchableTable
            SearchPlaceholder={"Search Invoice..."}
            SearchText={SearchText}
            setSearchText={setSearchText}
            CurrentData={StockStats.data}
            Columns={StockDataColumns}
          />
        )}
      </div>
      {OpenAddStockModal && (
        <AddStockModal
          Open={OpenAddStockModal}
          setOpen={setOpenAddStockModal}
        />
      )}
    </BodyWrapper>
  );
};

export default StockStats;
